// Test IDs for the Lore page.

export const LORE_PAGE = {
  section: "lore-page",
  heroSection: "lore-hero-section",
  disclaimer: "lore-disclaimer",
  seaSection: "lore-sea-section",
  citySection: "lore-city-section",
  regionSection: "lore-region-section",
  neighborsSection: "lore-neighbors-section",
  neighborCard: "lore-neighbor-card",
  ctaSection: "lore-cta-section",
};
